/** declare only http service related requests */

import { DeleteTraining, HttpTokens } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
import { AxiosResponse } from 'axios';

/**
 * @description delete training
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const TrainingDelete = (
  /** create can also refer to update for draft */
  prefix: string = 'training/delete',
  tokens: HttpTokens,
  /** id of training to delete */
  uid: string,
  hardRejection = true
): Promise<DeleteTraining> => {
  const instance = new AxiosService({ method: 'delete', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .delete(`${prefix}/${uid}`, config)
    .then((d: AxiosResponse<DeleteTraining>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<DeleteTraining>;
};
